module.exports = __webpack_public_path__ + "img/content_bg2.8fa7f72.png";